import React from "react"

// Next Image
import Image from "next/image"

// Icons
import ErrorIcon from "public/images/icons/error.png"

// MUI
import { Alert, Stack, Typography } from "@mui/material"

// ------------------------------------|| ERROR - COMPONENTS ||------------------------------------------

const Error = ({ sx = {}, desktopCentred = false, message = "" }) => {
  const centered = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  }

  return (
    <Stack direction='row' sx={{ ...sx, ...(desktopCentred && centered) }}>
      <Stack spacing={3} display='flex' justifyContent='center' alignItems='center'>
        <Image src={ErrorIcon} alt='error' width={300} />
        <Alert severity='error' variant='outlined' sx={{ borderRadius: 2 }}>
          <Typography variant='h6' fontWeight='bold' textAlign='center'>
            {message || " خطایی پیش آمده است !"}
          </Typography>
        </Alert>
      </Stack>
    </Stack>
  )
}

export default Error
